<p>customer-product-service-setup works!</p>
